import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import store, { initMiddleware } from './redux/store';

// Styling
import './stylesheets/main.scss';

// Components
import App from './routes/App';
initMiddleware();

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('app')
);
